import Typography from "@material-ui/core/Typography";
import React, { FC } from "react";

import classes from "./NoAdgroupsFound.module.scss";
import { AdvertiserType } from "../../../../../types/advertiserTypes";

type NoAdgroupsFoundProps = {
  selectedAdvertiser?: AdvertiserType;
};

const NoAdGroupsFound: FC<NoAdgroupsFoundProps> = ({ selectedAdvertiser }) => {
  return (
    <div className={classes.container}>
      <div className={`${classes.content} ${selectedAdvertiser ? classes.backgroundColor : ""}`}>
        <div>
          {selectedAdvertiser ? (
            <Typography variant="h2">
              There are no adgroup templates associated with "{selectedAdvertiser.name}" advertiser
            </Typography>
          ) : (
            <Typography variant="h2">Please, select Advertiser</Typography>
          )}
        </div>
      </div>
    </div>
  );
};

export default NoAdGroupsFound;
